import React from "react";
import "../../pages/style.css";
import { Container, Row, Col, Form, Button } from "react-bootstrap";

function Contactpage() {
  return (
    <div className="contactbackground">
      <Container className="contact-container">

        <h2 className="contacthead text-center">
          Contact <span>Me</span>
        </h2>

        <Row className="contact-wrapper">

          {/* LEFT SIDE – CONTACT INFO */}
          <Col md={5} className="contact-info">

            <h4>Let's Connect</h4>

            <p>
              I'm currently open to opportunities in
              <b> Full Stack Development</b>, <b>SOC Analysis</b>, and
              <b> 3D Animation / Modeling</b>.
            </p>

            <div className="contact-links">

              <p>
                📧 <b>Email</b><br/>
                donaldlopez@donaldlopezart.com
              </p>

              <p>
                💼 <b>LinkedIn</b><br/>
                <a href="https://linkedin.com" target="_blank" rel="noreferrer">
                  View Profile
                </a>
              </p>

              <p>
                🐙 <b>GitHub</b><br/>
                <a href="https://github.com" target="_blank" rel="noreferrer">
                  View Projects
                </a>
              </p>

              <p>
                💬 <b>WhatsApp</b><br/>
                <a
                  href="https://wa.me/9513850178"
                  target="_blank"
                  rel="noreferrer"
                >
                  Start Chat
                </a>
              </p>

            </div>

          </Col>

          {/* RIGHT SIDE – CONTACT FORM */}

          <Col md={7}>

            <Form
              action="https://formsubmit.co/donaldlopez@donaldlopezart.com"
              method="POST"
              className="contact-form"
            >

              <input type="hidden" name="_subject" value="Portfolio Message" />
              <input type="hidden" name="_captcha" value="false" />

              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Subject</Form.Label>
                <Form.Control
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="message"
                  placeholder="Write your message..."
                  required
                />
              </Form.Group>

              <Button variant="primary" type="submit" className="send-btn">
                Send Message
              </Button>

            </Form>

          </Col>

        </Row>

        <hr className="line" />

        <p className="copyright text-center">
          © {new Date().getFullYear()} <br />
          Designed & Built by <span>Donald Lopez</span>
        </p>

      </Container>
    </div>
  );
}

export default Contactpage;